import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dataCols'
})
export class DataColsPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}


@Pipe({ name: 'colSpecialChars' })
export class colSpecialCharsPipe implements PipeTransform {
  transform(value: string, args?: any): string {
    let repVal = value.replace(/DTD/g, ".");//7 underscores
    repVal = repVal.replace(/MNS/g, "-");//6 underscores
    repVal = repVal.replace(/PCG/g, "%");//5 underscores
    repVal = repVal.replace(/SLH/g, "/");//4 underscores
    repVal = repVal.replace(/ZYX/g, ")").replace(/XYZ/g, "(");//3, 2 underscores
    repVal = repVal.replace(/\_/g, " ");
    repVal = repVal.replace(/Point1/g, "Point(secs)");
    repVal = repVal.replace(/Point2/g, "Point(secs)");
    repVal = repVal.replace(/Point3/g, "Point(secs)");
    repVal = repVal.replace(/Point4/g, "Point(secs)");
    repVal = repVal.replace(/ERL1/g, "ERL(dB)");
    repVal = repVal.replace(/ERL2/g, "ERL(dB)");
    repVal = repVal.replace(/ERL3/g, "ERL(dB)");
    repVal = repVal.replace(/ERL4/g, "ERL(dB)");
    repVal = repVal.replace(/Delay1/g, "Delay(ms)");
    repVal = repVal.replace(/Delay2/g, "Delay(ms)");
    repVal = repVal.replace(/Delay3/g, "Delay(ms)");
    repVal = repVal.replace(/Delay4/g, "Delay(ms)");
    return repVal;
  }
}
